import { useState } from 'react';
import './AnalyticsGuide.css';

/**
 * PageGuide — a brief contextual intro banner for each analytics page.
 *
 * Props:
 *   title   (string)  – short page headline
 *   summary (string)  – 1-2 sentence explanation of what the page shows
 *   collapsible (bool) – whether the user can hide it (default true)
 */
export default function PageGuide({ title, summary, collapsible = true }) {
    const [collapsed, setCollapsed] = useState(false);

    if (!title && !summary) return null;

    return (
        <div className="page-guide">
            <div className="page-guide-header">
                <div className="page-guide-icon">ℹ</div>
                <div className="page-guide-title">{title}</div>
                {collapsible && (
                    <button
                        className="page-guide-toggle"
                        onClick={() => setCollapsed(c => !c)}
                        aria-label={collapsed ? 'Espandi guida' : 'Comprimi guida'}
                    >
                        {collapsed ? '▾ Mostra' : '▴ Nascondi'}
                    </button>
                )}
            </div>
            {!collapsed && summary && (
                <div className="page-guide-body">{summary}</div>
            )}
        </div>
    );
}
